import { IconButton } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { colors } from "../../../theme";

interface UploadButtonProps {
    onClick?: () => void;
    clicked?: boolean;
    label?: string;
}

/**
 * Per-track selection toggle. Mirrors Spotify's "saved to library" affordance:
 * a filled accent check when selected, a quiet outline ring when not.
 */
export default function UploadButton(props: UploadButtonProps) {
    const { onClick, clicked, label } = props;

    return (
        <IconButton
            onClick={onClick}
            aria-label={label ?? (clicked ? "Deselect track" : "Select track")}
            aria-pressed={!!clicked}
            sx={{
                width: 38,
                height: 38,
                color: clicked ? "primary.main" : colors.textMuted,
                transition: "color 120ms ease, transform 120ms ease",
                "&:hover": {
                    color: clicked ? "primary.light" : "text.primary",
                    transform: "scale(1.08)",
                    backgroundColor: "transparent",
                },
            }}
        >
            {clicked
                ? <CheckCircleIcon sx={{ fontSize: 24 }} />
                : <RadioButtonUncheckedIcon sx={{ fontSize: 24 }} />}
        </IconButton>
    );
}
